import TomSelect from "tom-select/dist/js/tom-select.base"
import remove_button from "tom-select/dist/js/plugins/remove_button"
import drag_drop from "tom-select/dist/js/plugins/drag_drop"

TomSelect.define('remove_button', remove_button)
TomSelect.define('drag_drop', drag_drop)

compiler("[tom-select-multi]", (element) => {
  const placeholder = element.getAttribute("data-placeholder")
  const duplicate = element.getAttribute("data-duplicate") === "true"
  const emptyOption = element.getAttribute("data-empty-option")

  const options = {
    placeholder: placeholder,
    hidePlaceholder: true,
    create: false,
    hideSelected: !duplicate,
    duplicates: duplicate,
    onInitialize: function() {
      this.popper = Popper.createPopper(this.control, this.dropdown)
    },
    onDropdownOpen: function() {
      this.popper.update()
    },
    plugins: {
      remove_button: {
        title: "Remove"
      },
      drag_drop: {}
    }
  }

  if (duplicate) {
    options["render"] = { option: renderForDuplicates }
  }

  const control = new TomSelect(element, options)

  if (duplicate) {
    // trigger re-render to show or hide options
    control.on("item_remove", updateOption)
    control.on("item_add",(value, item) => updateOption(value, item, {hide: true}))
  }

  function renderForDuplicates(data, escape) {
    let selectedValues = Array.from(element.selectedOptions).map((option) => option.value)
    let hide = (selectedValues.includes(data.value) || data.hide) && data.value !== emptyOption

    let display = hide ? "none" : "block"
    return `<div style="display:${display}">` + escape(data.text) + "</div>"
  }

  function stripText(text) {
    return text.replace(/\s*×\s*$/, "")
  }

  function updateOption(value, item, option) {
    control.updateOption(value, { value: value, text: stripText(item.innerText), hide: option?.hide })
  }
})
